import { useContext } from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    Avatar,
    Grid,
} from '@mui/material';
import { SportsBasketball } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { AppContext } from './all';

type Sport = {
    id: string;
    [key: string]: any;
};

type Props = {
    sports?: Sport[];
};

export function SttSportChips({ sports }: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();

    // -----| Render |-----
    if (!sports || sports.length === 0) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 4,
                    color: 'text.secondary',
                }}
            >
                <SportsBasketball sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
                <Typography variant="body1">
                    {t('generic.noSportsAssigned')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 1 }}>
            <Grid container spacing={2}>
                {sports.map((sport: any, idx: number) => (
                    <Grid size={{ xs: 6, sm: 4, md: 3 }} key={idx}>
                        <Card
                            variant="outlined"
                            sx={{
                                height: '100%',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    boxShadow: 2,
                                    borderColor: 'primary.dark',
                                },
                            }}
                        >
                            <CardContent
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    p: 2,
                                    '&:last-child': { pb: 2 },
                                }}
                            >
                                <Avatar
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        mb: 1,
                                        bgcolor: 'grey.100',
                                    }}
                                    alt={t(`sports.${sport.id}`, {
                                        defaultValue: sport.name || '',
                                    })}
                                    src={cxt?.getResource(
                                        `/sports/${sport.id}.png`,
                                    )}
                                />
                                <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                    }}
                                >
                                    {t(`sports.${sport.id}`, {
                                        defaultValue: sport.name || '',
                                    })}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
